// extracted by mini-css-extract-plugin
export default {"searchButton":"SearchButton_searchButton__d5lQV","searchButtonIcon":"SearchButton_searchButtonIcon__6LRy9"};